$('.icon-js').on('click', function() {
    var wLink = $(this).closest('.w-link');
    var children = wLink.siblings('.children-js');
    var link = $(this).siblings('.rubric-link');
    $(this).toggleClass('opened').toggleClass('closed');
    children.slideToggle(500);
    link.toggleClass('selected');
});